import Localization from './Localization.vue';

export default {
  Localization,
};
